import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Collapse } from 'reactstrap';
import Products from '../../Models/Products';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Common from "../../Models/Common";
class AffiliatorProfileDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            collapse: false,
            modal: false,
            sellerDetails: [],
            lastLoginTime: '',
            sellerid: '',
        };
        console.log(this.props.id)
        this.getlastLogin(this.props.id)
        this.getSellerDetails(this.props.id)
        this.getSellerDetailsId();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getSellerDetails(id) {
        Products.getProductsDetails(id).then(res => {
            console.log(res.data.seller)
            this.setState({ sellerDetails: res.data.seller })
        })
    }

    getSellerDetailsId() {
        Products.getProductsDetails(this.props.id).then(res => {
            res.data.seller.map(res =>
                this.setState({ sellerid: res.id })
            )
        })
    }

    getlastLogin(id) {
        Products.getProductsDetails(id).then(res => {
            this.setState({ lastLoginTime: res.data.hours_since_last_login })
        })
    }
    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }
    toggleAll() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }
    sellerName(name, id) {
        if (!localStorage.getItem('info')) {
            return (
                <div className="">
                    <div style={{ textAlign: 'center', fontSize: '13px', textDecoration: 'none', cursor: 'pointer' }} className="mt-2 " onClick={this.toggleAll.bind(this)}>{name}</div>
                    <Modal isOpen={this.state.modal} toggle={this.toggleAll.bind(this)} className={this.props.className}>
                        <ModalHeader toggle={this.toggleAll.bind(this)}></ModalHeader>
                        <ModalBody>
                            {this.props.t('0')}
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" onClick={this.toggleAll.bind(this)}>{this.props.t('10')}</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            )
        } else {
            return (
                <div className="">
                    <Link to={{ pathname: `/my-profile-view/users/${id}`, state: { id: id } }} style={{ textAlign: 'center', fontSize: '13px', textDecoration: 'none' }} className="mt-2 ">
                        {name}
                    </Link></div>
            )
        }
    }
    // onRead() {
    //     if (this.state.collapse === true) {
    //         // if (details !== null) {
    //         return (
    //             <div onClick={this.toggle.bind(this)} style={{ marginBottom: '1rem', cursor: 'pointer', border: '0px solid' }} className="card mt-2">
    //                 <Collapse isOpen={this.state.collapse} >
    //                     {details.split('\n').map(function (item, key) {
    //                         return (
    //                             <span key={key}>
    //                                 {item}
    //                                 <br />
    //                             </span>
    //                         )
    //                     })}
    //                 </Collapse>
    //                 <i className="fas fa-angle-up"></i>
    //             </div>
    //         )
    //         // } else {
    //         //     return (
    //         //         <div className="">
    //         //             {/* {this.state.personal_text} */}
    //         //         </div>
    //         //     )
    //         // }
    //         // return (<div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem', cursor: 'pointer' }}><i className="fas fa-angle-up"></i></div>
    //         // )
    //     } else {
    //         return (<div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem', cursor: 'pointer' }}>{this.props.t('6')}</div>
    //         )
    //     }
    // }

    details(details) {
        if (details === null || details === '') {
            return (
                <div>
                    {/* <span>{details}
                        <span id="dots"></span> <br /> <Collapse isOpen={this.state.collapse}>{details}</Collapse></span>
                    <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem' }}>{this.props.t('6')}</div>
                    {this.onRead()}*/}
                </div>
            )
        } else {
            const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
            if (this.state.collapse === true) {
                if (details !== null) {
                    return (
                        <div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer', border: '0px solid' }} className="card">
                            <Collapse isOpen={this.state.collapse} >
                                {details.split('\n').map(function (item, key) {
                                    return (
                                        <span key={key}>
                                            {item}
                                            <br />
                                        </span>
                                    )
                                })}
                            </Collapse>
                            <i className="fas fa-angle-up"></i>
                        </div>
                    )
                } else {
                    return (
                        <div className="">
                            {/* {this.state.personal_text} */}
                        </div>
                    )
                }
                // return (
                //     <div onClick={this.toggle.bind(this)} style={{ cursor: 'pointer', border: '0px solid' }} className="card">
                //         <Collapse isOpen={this.state.collapse}>{details}</Collapse>
                //
                //     </div>
                // )
            } else {
                return (<div onClick={this.toggle.bind(this)} className="card" style={{ cursor: 'pointer', border: '0px solid' }}>{renderHTML(details.substr(0, 50))}{this.props.t('6')}</div>
                )
            }
        }
    }

    contractProfile(id) {
        if (localStorage.getItem('info')) {
            let x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 3) {
                return (
                    <Link to={{
                        pathname: '/affiliator-chat-initiation' + "/" + encodeURIComponent(x.id + "/" + id),
                        state: {
                            sender_id: x.id,
                            receiver_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            } else if (x.user_type_id === 1) {
                return (
                    <Link to={{
                        pathname: '/chat-initiation' + "/" + encodeURIComponent(x.id + "/" + id),
                        state: {
                            sender_id: x.id,
                            receiver_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            } else if (x.user_type_id === 2 && x.id !== id) {
                return (
                    <Link to={{
                        pathname: '/seller-chat-initiation' + "/" + encodeURIComponent(x.id + "/" + id),
                        state: {
                            sender_id: x.id,
                            receiver_id: id
                        }
                    }} style={{ textDecoration: 'none' }} >
                        <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div>
                    </Link >
                )
            }
        }
    }

    render() {
        return (
            <div className="mt-4 ">
                <div className="cart_inner p-2">
                    <div className="cart_option">
                        <div className="payment_price">
                            <strong>
                                <b>{this.props.t('5')}</b>
                            </strong>
                        </div>
                        {this.state.sellerDetails.map(seller =>
                            <div>
                                <div className="text-center">
                                    <img src={Common.baseUrl+seller.img} alt="" className="rounded-circle p-2 mr-2" height="60%" width="40%" />
                                </div>
                                <div className="text-center">
                                    {this.sellerName(seller.first_name, seller.id)}
                                </div>
                                <div style={{ textAlign: "center", fontSize: "13px" }}> {seller.sex_text}</div>
                                {/* <div className="row pl-1">
                                    <div className="col-md-4 text-center" style={{ fontSize: '13px', }}>
                                        <span>
                                            {seller.profession}
                                        </span>
                                    </div> */}
                                {/* <div className="col-md-1 fa fa-check">

                                    </div> */}
                                {/* <div className="col-md-4" style={{ fontSize: '13px' }}>
                                        Non-Disclosure Agreement
                                    </div> */}
                                {/* <div className="col-md-1 fa fa-check">
                                    </div> */}
                                {/* </div> */}

                                {/* <div style={{ textAlign: "center", fontSize: "13px" }}> {this.props.t('1')}</div> */}
                                {this.contractProfile(seller.id)}
                                <div className="pl-1">
                                    <p>
                                        <font style={{ verticalAlign: 'inherit', marginBottom: '2px' }}>
                                            {seller.profession}
                                        </font>
                                    </p>
                                    <div>
                                        {this.details(seller.personal_details)}
                                        {/* <div onClick={this.toggle.bind(this)} className="mt-2" style={{ marginBottom: '1rem',cursor:'pointer' }}>{this.props.t('6')}</div> */}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
export { AffiliatorProfileDetails }

 AffiliatorProfileDetails = withTranslation('src_Components_Affiliator_AffiliatorProfileDetails')(AffiliatorProfileDetails);
